/**
 * Financial Statements validation utilities
 * Used by Step2 to validate all required FS files are uploaded
 */

/**
 * Checks if all three years have at least one financial statement file uploaded
 * @param fileGroup - Array of all uploaded files
 * @returns boolean - true if all financial years have FS files (y1, y2, y3)
 */
export const areAllFsYearsComplete = (fileGroup: any[]): boolean => {
  // Filter to get only financial statements
  const financialStatements = fileGroup.filter(({ type }: any) => type === 'financial-statement')
  
  // Define all required year keys (dynamic based on current financial year logic)
  // y1 = currentYear-3, y2 = currentYear-2, y3 = currentYear-1 (for FY)
  const requiredKeys = ['y1', 'y2', 'y3']
  
  // Check each year key has at least one file
  return requiredKeys.every((key) => {
    return financialStatements.some(({ file }: any) => {
      const filename = file?.filename || file?.name || ''
      return filename.startsWith(`${key}-`)
    })
  })
}
